import { Calculator } from '@/components/Calculator';

function App() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background-light dark:bg-background-dark">
      <Calculator />
    </div>
  );
}

export default App;
